import { Action, createReducer, on } from '@ngrx/store';
import { Student } from '../../model/student.model';
import { UserActionsUnions, UserActionTypes } from '../actions/user.actions';
import * as UserActions from '../actions/user.actions';

export interface UserData<T = any> {
    me: T | null,
    loading: boolean,
    hasError: boolean,
    message: string | null
}

export const initialState: UserData = {
    me: null,
    loading: false,
    hasError: false,
    message: null
};

const userReducer = createReducer(
    initialState,
    on(UserActions.GetUser, (state) => ({
        ...state,
        loading: true
    })),
    on(UserActions.GetUserSuccess, (state, action) => ({
        ...state,
        me: action.user,
        loading: false
    })),
    on(UserActions.GetUserFailure, (state) => ({
        ...state,
        me: null,
        loading: false
    })),
    on(UserActions.ResetPassword, (state) => ({
        ...state,
        loading: true,
        message: null
    })),
    on(UserActions.ResetPasswordSuccess, (state, action) => ({
        ...state,
        loading: false,
        message: action.message,
        hasError: false
    })),
    on(UserActions.ResetPasswordFailure, (state, action) => ({
        ...state,
        loading: false,
        message: action.message,
        hasError: true
    })),
    on(UserActions.ResetPasswordConfirm, (state) => ({
        ...state,
        loading: true
    })),
    on(UserActions.ResetPasswordConfirmFailure, (state, action) => ({
        ...state,
        loading: false,
        message: action.message,
        hasError: true
    })),
    on(UserActions.ResetPasswordConfirmSuccess, (state, action) => ({
        ...state,
        message: action.message,
        hasError: false,
        loading: false
    })),
    on(UserActions.ClearMessage, (state) => ({
        ...state,
        hasError: false,
        message: null
    })),
);

export function reducer(state: UserData | undefined, action: Action) {
    return userReducer(state, action);
}